(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["live-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-live-hero]');
  if (!root) return;

  var isLive = root.dataset.isLive === 'true';
  var windowHours = parseFloat(root.dataset.liveWindowHours || '3');
  var startedAt = window.localStorage.getItem('bjc_live_started');

  if (isLive) {
    if (!startedAt) {
      window.localStorage.setItem('bjc_live_started', Date.now());
    } else if (Date.now() - Number(startedAt) > windowHours * 3600 * 1000) {
      root.classList.remove('live-hero--live');
      root.classList.add('live-hero--offline');
      var badge = root.querySelector('.live-hero__badge');
      if (badge) badge.remove();
    }
  } else {
    window.localStorage.removeItem('bjc_live_started');
  }

  root.querySelectorAll('[data-live-hero-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: form.querySelector('input[name="id"]').value,
            quantity: 1
          }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = 'Try again';
          btn.disabled = false;
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
